import { z } from 'zod';
import { booleanQuery, idSchema } from './common.schema.js';
/**
 * A person a cost can be attributed to — work clothing, fuel, a tool bought for
 * somebody by name.
 *
 * Not a `User`: users are login accounts in three roles, and these people never
 * log in. Keeping them apart is what stops every labourer from turning up in
 * the role picker.
 */
export const employeeSchema = z.object({
    id: idSchema,
    fullName: z.string(),
    isActive: z.boolean(),
});
export const employeeListQuerySchema = z.object({
    includeInactive: booleanQuery(false),
});
export const createEmployeeSchema = z.object({
    fullName: z.string().trim().min(3, 'Podaj imię i nazwisko').max(80),
});
export const updateEmployeeSchema = createEmployeeSchema
    .partial()
    .extend({ isActive: z.boolean().optional() });
/**
 * The complete set of people on one invoice, sent whole.
 *
 * Adding and removing one at a time would need two more endpoints to express
 * what one list already says, and would leave the invoice half-edited if the
 * second call failed.
 */
export const setInvoiceEmployeesSchema = z.object({
    employeeIds: z.array(idSchema).max(50, 'Najwyżej 50 osób na fakturze'),
});
//# sourceMappingURL=employee.schema.js.map